module.exports = __webpack_public_path__ + "static/media/Muhammad Tariq Ahmed Khan.d37e2c23.jpg";